export default __webpack_public_path__ + "static/travel-feature-cards-half-page-7a67a489d00e86e882e28a706813b30b.png";